import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UsersListLayer from "../../components/User/UserListLayer";

const UserList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="User" />

        <UsersListLayer />
      </MasterLayout>
    </>
  );
};

export default UserList;
